// card-picker.js
//this card picker updates a new fake atc button with the new quantity and get the product variantid

class ProductCardPicker extends HTMLElement {
  constructor() {
    super();
    this.data = this.querySelector('[name="popin-atc-data"]');
    this.colorPicker = this.querySelector('product-color-picker');
    this.quantityPicker = this.querySelector('product-quantity-picker');
    this.buttonAddToCart = this.querySelector('.deployer-atc-button');
    this.isUpsell = this.querySelector('[name="toggle-is-upsell"]');
    this.productVariants = document.querySelectorAll('.product-variants--hidden .product-variant');
    this.productJSON = JSON.parse(this.querySelector('[type="application/json"]').innerHTML);
    this.windowVariants = document.querySelectorAll('[data-variant-id]');
  }

  connectedCallback() {
    this.listenEvents();
  }

  listenEvents() {
    document.addEventListener('td:colorChanged', (event) => {
      this.onColorChanged(event);
    });
    document.addEventListener('td:quantityChanged', (event) => {
      this.onQuantityChanged(event.detail.quantity);
      if (event.detail.id !== undefined) this.onVariantIdChanged(event.detail.id);
      this.toggleButtonAddToCart(event.detail.available);
    });
    document.addEventListener('deployer:variant-changed', (event) => {
      this.onVariantChanged(event.detail.variant);
    });
    this.buttonAddToCart.addEventListener('click', this.addToCart.bind(this));
  }

  toggleButtonAddToCart(available) {
    if (available === 'false') {
      this.buttonAddToCart.setAttribute('disabled', true);
    } else {
      this.buttonAddToCart.removeAttribute('disabled');
    }
  }

  isDeployerColorAvailable(action = 'color', color, upsell) {
    const data = this.data.querySelector(`[data-color="${color}"][data-is-upsell="${upsell.dataset.upsell}"]`);
    const colorPickerInput = this.querySelector('product-color-picker input');

    if (data === undefined || data === null) {
      if (action === 'color') {
        this.buttonAddToCart.dataset.isUpsell = 'false';
        this.buttonAddToCart.dataset.id = this.data.querySelector(`[data-color="${color}"][data-is-upsell="false"]`).value;
        this.isUpsell.setAttribute('disabled', true);
        this.isUpsell.classList.remove('upsell__unit--checked');
      }
      if (action === 'upsell') {
        this.buttonAddToCart.dataset.isUpsell = 'true';
        colorPickerInput.classList.remove('active');
      }
    } else {
      this.buttonAddToCart.dataset.id = data.value;
      this.buttonAddToCart.removeAttribute('disabled');
      this.isUpsell.removeAttribute('disabled');
      colorPickerInput.removeAttribute('disabled');
    }
  }

  onColorChanged(event) {
    this.isDeployerColorAvailable('color', event.detail.color.value, this.isUpsell);
  }

  onQuantityChanged(quantity) {
    this.buttonAddToCart.dataset.quantity = quantity;
  }

  // update id in atc button
  onVariantIdChanged(variantId) {
    this.buttonAddToCart.dataset.id = variantId;
  }

  onVariantChanged(variant) {
    this.isVariantAvailable(variant);
    this.selectFirstAvailableVariant();
    this.buttonAddToCart.dataset.id = variant.id;
    this.getCurrentVariantMetafieldList(variant);
  }

  selectFirstAvailableVariant() {
    this.querySelectorAll('.pack__unit').forEach((button, index) => {
      button.removeAttribute('data-selected');
      if (index === 0) {
        button.setAttribute('data-selected', 'true');
      }
    });
  }

  isVariantAvailable(variant) {
    if (variant.available === true) {
      this.buttonAddToCart.removeAttribute('disabled');
      this.buttonAddToCart.innerHTML = window.themeVariables.strings.productFormAddToCart;
    } else {
      this.buttonAddToCart.setAttribute('disabled', true);
      this.buttonAddToCart.innerHTML = window.themeVariables.strings.productFormSoldOut;
    }
  }

  buildVariantsArray() {
    let variantsArray = [];

    if (this.productVariants.length > 0) {
      this.productVariants.forEach((variant) => {
        variantsArray.push({
          id: parseInt(variant.dataset.variantId),
          title: variant.dataset.variantTitle,
          featured_image: {
            src: variant.dataset.variantImg == '' ? null : variant.dataset.variantImg,
          },
          price: parseInt(variant.dataset.variantPrice),
          compare_at_price: variant.dataset.variantCompareAtPrice == '' ? null : parseInt(variant.dataset.variantCompareAtPrice),
          toHide: variant.dataset.variantMetafieldsToHide == 'false' ? false : true,
          complementaryVariants: variant.dataset.variantMetafieldsComplementaryVariants,
        });
      });
    }

    return variantsArray;
  }

  extractComplementaryVariants(variant, variantsArray) {
    const windowCurrentVariant = document.querySelector(`[data-variant-id='${variant.id}']`);

    if (!windowCurrentVariant) {
      this.handleNoVariantFound(variant);
      return;
    }

    if (!windowCurrentVariant.dataset.variantMetafieldsComplementaryVariants) {
      this.handleNoComplementaryVariantList(variant);
      return;
    }

    this.quantityPicker.style.display = 'block';

    const complementaryVariantIds = windowCurrentVariant.dataset.variantMetafieldsComplementaryVariants.split(',');
    return variantsArray.filter((v) => complementaryVariantIds.includes(String(v.id)));
  }

  handleNoVariantFound(variant) {
    console.error('No element found with the specified variant.id');
    this.quantityPicker.style.display = 'none';
    this.buttonAddToCart.dataset.id = variant.id;
  }

  handleNoComplementaryVariantList(variant) {
    console.error('No complementaryVariantList found');
    this.quantityPicker.style.display = 'none';
    this.buttonAddToCart.dataset.id = variant.id;
  }

  getCurrentVariantMetafieldList(variant) {
    const variantsArray = this.buildVariantsArray();
    const matchingVariants = this.extractComplementaryVariants(variant, variantsArray);

    if (matchingVariants && matchingVariants.length > 0) {
      this.showCurrentVariantMetafieldList(matchingVariants);
    }

    return matchingVariants;
  }

  showCurrentVariantMetafieldList(matchingVariants) {
    this.quantityPicker.querySelectorAll('.pack__unit').forEach((button, index) => {
      const buttonTitle = button.querySelector('.pack__title');
      const buttonImage = button.querySelector('.pack__image');
      const buttonPrice = button.querySelector('.pack__price');
      const buttonDiscount = button.querySelector('.pack__promo_image');

      const variant = matchingVariants[index];
      if (variant) {
        if (variant.title && buttonTitle) {
          buttonTitle.innerHTML = variant.title;
        }
        if (variant.featured_image.src && buttonImage) {
          buttonImage.src = variant.featured_image.src;
        }
        if (variant.id) {
          button.dataset.packId = variant.id;
        }
        if (variant.compare_at_price === null || variant.price === variant.compare_at_price) {
          buttonPrice.innerHTML = this.formatPrice(variant.price / 100);
        } else {
          buttonPrice.innerHTML = `${this.formatPrice(variant.price / 100)} <span>${this.formatPrice(
            variant.compare_at_price / 100,
          )}</span>`;
        }
        if (variant.compare_at_price != null) {
          let percentageDifference = Math.round(((variant.compare_at_price - variant.price) / variant.compare_at_price) * 100);
          buttonDiscount.innerHTML = `-${percentageDifference}%`;
        }
      }
    });
  }

  formatPrice(price) {
    if (isNaN(price)) {
      //console.error('Invalid price value:', price);
      return price;
    }
    return Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' }).format(price);
  }

  onSelectedButton(button) {
    const globalThis = this;
    const quantity = button.dataset.packQty;

    globalThis.onQuantityChanged(quantity);
    button.setAttribute('data-selected', 'true');
  }

  onDeselectedButton(button) {
    button.removeAttribute('data-selected');
  }

  addToCart() {
    const fetchedData = {
      id: this.buttonAddToCart.dataset.id,
      quantity: this.buttonAddToCart.dataset.quantity,
    };

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(fetchedData),
    })
      .then(async (response) => {
        const responseJson = await response.json();
        fetch(`${window.themeVariables.routes.cartUrl}.js`).then(
          async (response2) => {
            const cartContent = await response2.json();
            document.documentElement.dispatchEvent(
              new CustomEvent('cart:updated', {
                bubbles: true,
                detail: {
                  cart: cartContent,
                },
              })
            );
            cartContent['sections'] = responseJson['sections'];
            document.documentElement.dispatchEvent(
              new CustomEvent('cart:refresh', {
                bubbles: true,
                detail: {
                  cart: cartContent,
                  openMiniCart:
                    window.themeVariables.settings.cartType === 'drawer' &&
                    this.closest('.drawer') === null,
                },
              })
            );
          })
      })
      .catch((error) => {
        console.error('Error:', error);
      });
  }
}

window.customElements.define('product-card-picker', ProductCardPicker);

class ProductQuantityPicker extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.querySelectorAll('button').forEach((button, generalIndex) => {
      button.addEventListener('click', (element) => {
        const buttonPackId = element.target.closest('button').dataset.packId;
        document.querySelectorAll(`button[data-pack-id="${buttonPackId}"]`).forEach((button) => {
          button.click();
        });
      
        this.querySelectorAll('button').forEach((button, childrenIndex) => {
          if (generalIndex === childrenIndex) {
            this.onSelectedButton(button);
          } else {
            this.onDeselectedButton(button);
          }
        });
      });
    });
  }

  onSelectedButton(button) {
    button.setAttribute('data-selected', 'true');

    document.dispatchEvent(
      new CustomEvent('td:quantityChanged', {
        detail: {
          quantity: button.dataset.packQty,
          id: button.dataset.packId,
          available: button.dataset.available,
        },
      }),
    );
  }

  onDeselectedButton(button) {
    button.removeAttribute('data-selected');
  }
}

window.customElements.define('product-quantity-picker', ProductQuantityPicker);

// color-picker.js
class ProductColorPicker extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const globalThis = this;

    this.inputs = this.querySelectorAll('input');
    this.inputs.forEach((input) => {
      input.addEventListener('change', function () {
        globalThis.inputChanged(input);
        document.dispatchEvent(
          new CustomEvent('td:colorChanged', {
            detail: {
              color: input,
            },
          }),
        );
      });
    });
  }

  inputChanged(currentInput) {
    this.inputs.forEach((input) => {
      if (input === currentInput) {
        input.classList.add('active');
      } else {
        input.classList.remove('active');
      }
    });
  }
}

window.customElements.define('product-color-picker', ProductColorPicker);